import type { SimpleLocation } from '../types'
import { compareStringsAccentInsensitive } from '../../../../../shared/util/compare'

function compact(value: string): string {
  return value.replace(/\s+/g, '').toLowerCase()
}

export function dedupeLocations(locations: SimpleLocation[]): SimpleLocation[] {
  const byId = new Map<string, SimpleLocation>()
  for (const loc of locations) {
    if (!byId.has(loc.id)) byId.set(loc.id, loc)
  }
  return Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name, 'es'))
}

export function filterLocationsByQuery(
  locations: SimpleLocation[],
  query: string,
  limit = 50,
): SimpleLocation[] {
  const q = query.trim()
  if (!q) return []

  const qLower = q.toLowerCase()
  const qCompact = compact(q)

  const scored = locations
    .map((loc) => {
      const nameLower = loc.name.toLowerCase()
      const nameCompact = compact(loc.name)
      let score = 0

      if (compareStringsAccentInsensitive(q, loc.name)) score = 100
      else if (nameLower.startsWith(qLower)) score = 92
      else if (nameCompact.startsWith(qCompact)) score = 88
      else if (nameLower.includes(qLower)) score = 72
      else if (nameCompact.includes(qCompact)) score = 68

      return { loc, score }
    })
    .filter((row) => row.score > 0)
    .sort(
      (a, b) =>
        b.score - a.score || a.loc.name.localeCompare(b.loc.name, 'es'),
    )

  return scored.slice(0, limit).map((row) => row.loc)
}

export function tamLocationFilterOptions(
  options: SimpleLocation[],
  state: { inputValue: string },
): SimpleLocation[] {
  return filterLocationsByQuery(options, state.inputValue)
}
